import React from 'react';
import ReactDOM from 'react-dom';
import classNames from './DeleteClassModal.module.scss';
import classnames from 'classnames';
import { Trans } from 'react-i18next';
import { useAdminTranslation } from '@/admin/hooks/useAdminTranslation';
import { Transition } from 'react-transition-group';
import TheButton from '@/components/school-management/TheButton/TheButton';
import AppLoaderCircle from '@/components/AppLoaderCircle';

interface DeleteClassModalProps {
  show: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
  activeStudentsCount?: number;
}

const DeleteClassModal: React.FC<DeleteClassModalProps> = ({
  show,
  onClose,
  onConfirm,
  isLoading = false,
  activeStudentsCount = 0,
}) => {
  const { t } = useAdminTranslation();

  const modalContent = (
    <Transition in={show} timeout={400} mountOnEnter unmountOnExit>
      {state => (
        <div className={classNames.deleteModalOverlay}>
          <div className={classnames(classNames.modal, classNames.DeleteModal, `fade-${state}`)}>
            <h2>{t('schoolDetailsPage.classes.deleteClassModal.title')}</h2>
            <span className={classNames.description}>
              {activeStudentsCount === 0 ? (
                t('schoolDetailsPage.classes.deleteClassModal.descriptionEmpty')
              ) : (
                <Trans
                  ns='admin'
                  i18nKey={
                    activeStudentsCount === 1
                      ? 'schoolDetailsPage.classes.deleteClassModal.descriptionSingular'
                      : 'schoolDetailsPage.classes.deleteClassModal.description'
                  }
                  values={{ count: activeStudentsCount }}
                  components={{ strong: <strong /> }}
                />
              )}
            </span>
            <div className={classNames.buttonContainer}>
              {isLoading ? (
                <div className={classNames.loader}>
                  <AppLoaderCircle />
                </div>
              ) : (
                <>
                  <TheButton
                    className={classNames.deleteBtn}
                    text={t('schoolDetailsPage.classes.deleteClassModal.confirmButton')}
                    shouldRecolor={false}
                    emitOnClick={onConfirm}
                  />
                  <TheButton
                    className={classNames.cancelBtn}
                    text={t('common.cancel')}
                    plain
                    emitOnClick={onClose}
                  />
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </Transition>
  );

  return ReactDOM.createPortal(modalContent, document.body);
};

export default DeleteClassModal;
